<mat-card>
  <mat-card-title>{{ '+USER_DETAILS.PERSONAL_DETAILS.LANGUAGE' | translate }}</mat-card-title>
  <mat-card-content>
    <form [formGroup]="formGroup" class="flex flex-col">
      <div class="flex flex-row gap-[24px]">
        <mat-form-field
          mat-select-height-large
          class="flex-[25%] max-w-[25%] lt-sm:flex-[45%] lt-sm:max-w-[45%]"
          id="language"
        >
          <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.LANGUAGE' | translate }}</mat-label>
          <mat-select
            [formControl]="formGroup.controls.language"
            data-at-language-edit
            fieldTextContentTooltip
          >
            <mat-option
              *ngFor="let language of languages"
              [value]="language.code"
              gtm="onSelect"
              gtmAction="Language"
              gtmCategory="userLanguageDetails"
              fieldTextContentTooltip
            >
              {{ language.name | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions class="flex flex-row gap-[8px] justify-end items-center" align="end">
    <button
      id="cancel-btn"
      mat-button
      color="primary"
      gtm="onCancelDialog"
      gtmCategory="userLanguageDetails"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      id="save-btn"
      mat-raised-button
      color="primary"
      [disabled]="formGroup.invalid"
      gtm="onSave"
      gtmCategory="userLanguageDetails"
      (click)="onSave()"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
